import { Navigate, Route, Routes } from "react-router-dom";
import AwardsSearchLayout from "../components/AwardsSearch/AwardsSearchLayout.jsx";
import AwardsResults from "../components/AwardsSearch/AwardsResults.jsx";
import AwardDetail from "../components/AwardsSearch/AwardDetail.jsx";
import UTAFacultyAwards from "../components/UTAFacultyAwards/UTAFacultyAwards.jsx";
import NetworkGraph from "../components/AwardsAnalyticsStatistics/NetworkGraph.js";
import NetworkGraphAwardees from "../components/NetworkGraphAwardees/Awardees.jsx";
import Societies from "../components/Societies/Societies.jsx";
import Tips from "../components/Tips/Tips.jsx";
import AboutUs from "../components/AboutUs/About.jsx";
import UpdateLog from "../components/UpdateLog/UpdateLog.jsx";
import Login from "../components/Login/Login.jsx";
import ProtectedRoute from "../components/Shared/ProtectedRoute.jsx";
import Analyses from "../components/Analyses/Analyses.jsx";
import NetworkLandingRedirect from "../components/Home/NetworkLandingRedirect.jsx";

// RAG surface: registered but hidden. ragRoutes() (below) returns null unless
// REACT_APP_ENABLE_RAG=true, so the routes exist in the tree but are unreachable
// until that build-env flag flips - see src/config/ragRoutes.jsx and featureFlags.js.
import { ragRoutes } from "./ragRoutes.jsx";
import { adminRoutes } from "./adminRoutes.jsx";

const RoutesConfig = () => {
  return (
    <Routes>
      <Route path="/" element={<NetworkLandingRedirect />} />
      <Route element={<AwardsSearchLayout />}>
        <Route path="/awards" element={<AwardsResults />} />
        <Route path="/award/:id" element={<AwardDetail />} />
      </Route>
      <Route
        path="/awardees"
        element={<Navigate to="/awards?type=awardees" replace />}
      />
      <Route path="/uta_faculty_awards" element={<UTAFacultyAwards />} />
      <Route path="/correlated_awards" element={<NetworkGraph />} />
      <Route path="/network_awardees" element={<NetworkGraphAwardees />} />
      <Route path="/societies" element={<Societies />} />
      <Route path="/tips" element={<Tips />} />
      <Route path="/about" element={<AboutUs />} />
      <Route
        path="/update-log"
        element={
          <ProtectedRoute>
            <UpdateLog />
          </ProtectedRoute>
        }
      />
      <Route
        path="/analyses"
        element={
          <ProtectedRoute>
            <Analyses />
          </ProtectedRoute>
        }
      />
      <Route path="/login" element={<Login />} />
      {adminRoutes()}
      {/* RAG ACTIVATION: uncomment to enable the flag-gated /rag and /signup routes */}
      {ragRoutes()}
    </Routes>
  );
};

export default RoutesConfig;
